/* 
smartMart added: send custom Amplitude events (Quiz etc.-related)
smartMart added: custom behaviour for Websummin quiz like https://winest.store/en/pages/quiz?landing=websummit 
20241108-2137
*/
const smartMart = new (smartMartCf())();
smartMart.init();
window.smartMart = smartMart;
function smartMartCf() {
	return class smartMartClass {
		isWebsummitQuiz = false; // preini Websummit Quiz page
		isWebsummitResult = false; // preini Websummit Result page 
		
		init() {console.log('smartMart initialized');}
		iniWebsummitResult() {
			// mark Websummit Result page
			this.isWebsummitResult = true;
			// log done
			console.log('smartMart.iniWebsummitResult(): done');
		}
		iniWebsummitQuiz() {
			const websummitQuizCfg = {
				startPicturesSelector: '#main > section.shopify-section.page-quiz .quiz-page-start-image > picture',
				startFormNameLabelSelector: 'label[for="qa-quiz-page-start-name"]',
				startFormNameInputSelector: 'input#qa-quiz-page-start-name',
				startPictureFirstMediaBasename: 'quiz-websummit-start.websummit',
				startPictureSecondMediaBasename: 'quiz-websummit-start.winest'
			};

			// mark Websummit Quiz page
			this.isWebsummitQuiz = true;

			// take elements:
			const startPictures = document.querySelectorAll(websummitQuizCfg.startPicturesSelector);
			const startFormNameLabel = document.querySelector(websummitQuizCfg.startFormNameLabelSelector);
			const startFormNameInput = document.querySelector(websummitQuizCfg.startFormNameInputSelector);

			// elements changes:
			// form-related
			startFormNameLabel.textContent = startFormNameLabel.textContent.replace('*',''); // no asterisk
			startFormNameInput.required = false; // can be empty
			// pictures-related
			startPictures[0].querySelector('source').srcset = 
				`//winest.store/cdn/shop/files/${websummitQuizCfg.startPictureFirstMediaBasename}_350x.png 1x, `+
				`//winest.store/cdn/shop/files/${websummitQuizCfg.startPictureFirstMediaBasename}_700x.png 2x`;
			startPictures[0].querySelector('img').src = 
				`//winest.store/cdn/shop/files/${websummitQuizCfg.startPictureFirstMediaBasename}.png`;
			startPictures[0].querySelector('img').srcset = 
				`//winest.store/cdn/shop/files/${websummitQuizCfg.startPictureFirstMediaBasename}_570x.png 1x, `+
				`//winest.store/cdn/shop/files/${websummitQuizCfg.startPictureFirstMediaBasename}_1140x.png 2x`;
			startPictures[1].querySelector('source').srcset = 
				`//winest.store/cdn/shop/files/${websummitQuizCfg.startPictureSecondMediaBasename}_350x.png 1x, `+
				`//winest.store/cdn/shop/files/${websummitQuizCfg.startPictureSecondMediaBasename}_700x.png 2x`;
			startPictures[1].querySelector('img').src = 
				`//winest.store/cdn/shop/files/${websummitQuizCfg.startPictureSecondMediaBasename}.png`;
			startPictures[1].querySelector('img').srcset = 
				`//winest.store/cdn/shop/files/${websummitQuizCfg.startPictureSecondMediaBasename}_570x.png 1x, `+
				`//winest.store/cdn/shop/files/${websummitQuizCfg.startPictureSecondMediaBasename}_1140x.png 2x`;

			// log done
			console.log('smartMart.iniWebsummitQuiz(): done');
		}
		iniHomepageObserve() {
			// prep config, parts to observe:
			const observeCfg = {
				intersectionMinRatio: .3,
				intersectionMaxRatio: 1,
				// i.e. [.1, .2, ... .9, 1]
				intersectionThresholds: [...Array(10).keys()].map(i => (1 + 1*i)/10)
			}
			const partsCfg = [
				{
					intersectionMinRatio: .3, // specific for section
					sectionType: 'Collection',
					sectionSelector: 'section.shopify-section.products-list-section',
					titleSubSelector: '.section-inner-wrapper h3',
					hrefSubSelector: 'a'
				},
				{
					sectionType: 'Full-width banner',
					sectionSelector: 'section.shopify-section.heading-with-image-section',
					titleSubSelector: 'figcapture h2',
					hrefSubSelector: 'a'
				},
				{
					intersectionMinRatio: .5, // specific for section
					sectionType: 'Half-width linked image banner',
					sectionSelector: 'section.shopify-section.linked-images-section li',
					titleSubSelector: 'h3',
					hrefSubSelector: 'a'
				},
				{
					intersectionMinRatio: .3, // specific for section
					sectionType: 'Sommelier',
					sectionSelector: 'section.shopify-section.sommelier-section'
				},
				{
					intersectionMinRatio: .2, // specific for section
					sectionType: 'Loox Reviews',
					sectionSelector: 'div.shopify-section .shopify-app-block[id^="shopify-block-loox_reviews_loox_agg_section"]'
				}, 
				{
					intersectionMinRatio: .2, // specific for section
					sectionType: 'Footer',
					sectionSelector: 'footer#shopify-section-footer'
				} 
			];

			// loop parts to assing:
			for (const part of partsCfg) {
				// take elements:
				const sectionElements = document.querySelectorAll(part.sectionSelector);
				
				// prep observer,
				const observer = new IntersectionObserver((entries, observer) => {
					entries.forEach((entry) => {
						// prep compare:
						// to specific part' min, otherwise to config min:
						const minRatioToCampare = ((part.hasOwnProperty('intersectionMinRatio')) ? part.intersectionMinRatio : observeCfg.intersectionMinRatio);
						
						// skip non/low-intersected i.e. < .25 ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
						if (entry.intersectionRatio < minRatioToCampare) return;   

						// refresh obtained intersection,
						// e.g. "0" -> "0.93585"
						let intersectionObtained = parseFloat(entry.target.dataset.intersectionObtained);
						if (entry.intersectionRatio > intersectionObtained) {
							entry.target.dataset.intersectionObtained = entry.intersectionRatio;
						}
						
						// check/mark/prep MIN intersection ratio-related event: ===========
						if (
							entry.intersectionRatio >= minRatioToCampare &&
							!entry.target.dataset.minEventHappened // event not yet sent
						) {
							// prep data for event:
							let eventName = 'SECTION:VIEWED';
							let eventProps = { // ini
								sectionType: part.sectionType
							}
							// event props:
							let title = (part.hasOwnProperty('titleSubSelector')) ?
								entry.target.querySelector(part.titleSubSelector)?.innerText?.trim() : null;
							let href = (part.hasOwnProperty('hrefSubSelector')) ?
								entry.target.querySelector(part.hrefSubSelector)?.href?.trim() : null;
							let url = (href) ?
								new URL(href) : null; 
							let pathname = (url !== null) ? 
								url.pathname : null;
						
							// conditionally combine props:
							if (title) eventProps.title = title;  
							if (pathname) eventProps.pathname = pathname;  

							// mark as event sent
							entry.target.dataset.minEventHappened = 'sent';
							// publish Shopify custom event:
							Shopify.analytics.publish(eventName,eventProps);
							console.log('Shopify analyitics event publish:',eventName,eventProps);
						}

						//TODO check/mark/prep MIN intersection ratio event (later?..):
					});
				}, {rootMargin: "0px", threshold: observeCfg.intersectionThresholds});
				
				// observe every found:
				sectionElements.forEach((element, index) => {
					// ini some datasets:
					element.dataset.sectionType = part.sectionType;
					element.dataset.intersectionObtained = 0;
					// observe
					observer.observe(element);
				});
			}
			// log done
			console.log('smartMart.iniHomepageObserve(): done');
		}
		iniTasteprofileObserve() {
			// prep config to observe:
			const observeCfg = {
				intersectionMinRatio: .75,
				intersectionMaxRatio: 1,
				// i.e. [.1, .15, .2, .25 ... .9, .95, 1]
				intersectionThresholds: [...Array(19).keys()].map(i => (1 + .5*i)/10),
				sectionType: 'TasteProfile recommendation',
				// Only native wine tiles: editorial cards and nested aroma images are not products.
				productSelector: '#main .preference-products ul.product-card-list-preference > li.preference-card',
				titleSubSelector: '.product-card-preference h4',
				matchSubSelector: '.product-card-preference .product-card-preference-match',
				priceSubSelector: '.product-card-preference .product-card-price',
				hrefSubSelector: 'a'
			} 

			// take elements:
			const sectionElements = document.querySelectorAll(observeCfg.productSelector);

			// prep observer:
			const observer = new IntersectionObserver((entries, observer) => {
				entries.forEach((entry) => {
					// prep compare:
					const minRatioToCampare = observeCfg.intersectionMinRatio;

					// skip non/low-intersected i.e. < .25 ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
					if (entry.intersectionRatio < minRatioToCampare) return;

					// refresh obtained intersection,
					// e.g. "0" -> "0.93585"
					let intersectionObtained = parseFloat(entry.target.dataset.intersectionObtained);
					if (entry.intersectionRatio > intersectionObtained) {
						entry.target.dataset.intersectionObtained = entry.intersectionRatio;
					}

					// check/mark/prep MIN intersection ratio-related event: =============
					if (
						entry.intersectionRatio >= minRatioToCampare &&
						!entry.target.dataset.minEventHappened // event not yet sent
					) {
						// prep data for event:
						let eventName = 'RECOMMENDATION:SHOWN';
						let eventProps = { // ini
							sectionType: observeCfg.sectionType
						}
						// event props:
						let title = entry.target.querySelector(observeCfg.titleSubSelector)?.innerText?.trim();
						let match = entry.target.querySelector(observeCfg.matchSubSelector)?.innerText?.trim();
						let price = entry.target.querySelector(observeCfg.priceSubSelector)?.innerText?.trim();
						let href = entry.target.querySelector(observeCfg.hrefSubSelector)?.href?.trim();
						let url = (href) ?
							new URL(href) : null; 
						let pathname = (url !== null) ? 
							url.pathname : null;
					
						// prep/combine props:
						eventProps.title = title;
						// '1' -> 1
						eventProps.itemNo = parseInt(entry.target.dataset.itemNo);  
						// e.g. '91% MATCH' | '"91% התאמה' -> 91
						eventProps.matching = (match) ? parseInt(match.replace(/[^0-9]/,'')) : null;
						// e.g. '₪ 189' - > 89
						eventProps.price = (price) ? parseFloat(price.replace(/[^0-9.]/,'')) : null;  
						// e.g. '/en/collections/taste-profile/products/dalton-coast-to-coast-2019' -> 'dalton-coast-to-coast-2019'
						eventProps.handle = pathname?.replace(/^.+\//g,'');  
					 
						// mark as event sent
						entry.target.dataset.minEventHappened = 'sent';
						// publish Shopify custom event:
						Shopify.analytics.publish(eventName,eventProps);
						console.log('Shopify analyitics event publish:',eventName,eventProps);
					}

					//TODO check/mark/prep MIN intersection ratio event (later?..):
				});
			}, {rootMargin: "0px", threshold: observeCfg.intersectionThresholds});
			
			// observe every found:
			sectionElements.forEach((element, index) => {
				// ini some datasets:
				element.dataset.sectionType = observeCfg.sectionType;
				element.dataset.itemNo = index + 1;
				element.dataset.intersectionObtained = 0;
				// observe
				observer.observe(element);
			});
			// log done
			console.log('smartMart.iniTesteprofileObserve(): done');
		}
		handleLoaded(e) {
			// prep logical marks:
			const isHomepage = ['/', '/en'].includes(document.location.pathname);
			const isWebsummitQuiz = !!document.location.search.match(/landing=websummit/);
			const isWebsummitResult = !!document.location.href.match(/\/pages\/websummit\?result/);

			// dependent:
			if (isHomepage) smartMart.iniHomepageObserve();
			if (isWebsummitQuiz) smartMart.iniWebsummitQuiz();
			if (isWebsummitResult) smartMart.iniWebsummitResult();
		}
		handleEvent(e) {
			// Case catch, CustomEvent etc:
			let theButton = (e.target.nodeName == 'BUTTON') ? e.target : e.target.closest('button');
			let isClickFilterTreeHeader = (
				e.type == 'click' &&
				theButton &&
				// e.g. '<button aria-controls="boost-pfs-filter-tree-pf-t-country" ...>:
				theButton.attributes.getNamedItem('aria-controls')?.value?.startsWith('boost-pfs-filter-tree-pf-t-') 
			);

			// Filter tree header ====================================================
			if (isClickFilterTreeHeader) {
				// To catch checked opened/closed item:
				// N.B.: invert because resulting state is opposite (close -> open and vice versa)
				let filterState = !theButton.closest('.boost-pfs-filter-option-box').querySelector('.boost-pfs-filter-option-content').classList.contains('content-is-open')
				let lang = document.body.parentElement.lang;
				// e.g. '?pf_t_red=primary::red::LIGHT+BODIED&pf_t_red=primary::red::FRUITY' 
				//  -> ['primary::red::LIGHT BODIED', 'primary::red::FRUITY']
				let searchStringItems = decodeURIComponent(document.location.search).slice(1).split('&').map((item)=>{
						return item.replaceAll(/^[^=]+=/g,'').replaceAll('+', ' ')
				});
				// empty case: [''] -> []
				searchStringItems = (searchStringItems.length == 1 && searchStringItems[0] == '') ? [] : searchStringItems;

				let filterTreeClassname = theButton.attributes.getNamedItem('aria-controls').value;
				// take filter option form :Map: 
				// e.g. 'boost-pfs-filter-tree-pf-t-sweet-and-fortified' - > 'pf_t_sweet_and_fortified'
				let filterTreeKey = filterTreeClassname.replace('boost-pfs-filter-tree-','').replaceAll('-','_');
				let filterOption = e.view?.boostPFS?.filter?.filterTrees?.at(0)?.filterOptions.get(filterTreeKey);
				// take 1st filterItem key from filterItems :Map:
				// e.g. :Map {isInit: true, ..., filterItems: {'primary::country::USA' => e, ...}}
				// -> "primary::occasion::BRUNCH" -> "occasion"
				let tagGroupBaseName = filterOption.filterItems.entries().next().value.at(0).replaceAll(/(^primary::|::[^:]+$)/g,'');
				
				let theDataFound = {
					filterState: filterState,
					tagGroupBaseName: tagGroupBaseName,
					lang: lang,
					searchStringItems: searchStringItems,
				}
				
				let eventName = 'FILTER:TREE';
				let eventProps = theDataFound;
				// N.B.: Shopify analyitics instead of direct Amplitude:
				Shopify.analytics.publish(eventName,eventProps);
				console.log('Shopify analyitics event publish:',eventName,eventProps);
			}
		}
	}
}

// click > QUIZ:STARTED, FILTER:* & other --------------------------------------
document.addEventListener('click', (e) => {
	// prep:
	// QUIZ:STARTED
	let closestQuizStartForm = e.target.closest('form.quiz-page-start-form');
	let isButton = e.target.nodeName == 'BUTTON';
	// FILTER:*
	let isClearAllFilters = e.target.classList.contains('boost-pfs-filter-clear-all');
	let isFilterOpen = e.target.closest('#qa-header-filter-button');
	let isFilterClose = e.target.classList.contains('boost-pfs-filter-close'); 
	let isFilterCloseIcon =  e.target.closest('svg') && e.target.closest('header.filters-popup-header'); 
	let eventFilterOptionItem = e.target.closest('.boost-pfs-filter-option-item');
	let isFilterOptionAll = eventFilterOptionItem && eventFilterOptionItem.classList.contains('choose-all');
	// e.g. '?pf_t_red=primary::red::LIGHT+BODIED&pf_t_red=primary::red::FRUITY' 
	//  -> ['primary::red::LIGHT BODIED', 'primary::red::FRUITY']
	let searchStringItems = decodeURIComponent(document.location.search).slice(1).split('&').map((item)=>{
			return item.replaceAll(/^[^=]+=/g,'').replaceAll('+', ' ')
	});
	// empty case: [''] -> []
	searchStringItems = (searchStringItems.length == 1 && searchStringItems[0] == '') ? [] : searchStringItems;
	// BANNER:*
	// Full-width banner
	let closestHeadingWithImageSection = e.target.closest('section.shopify-section.heading-with-image-section');
	// Half-width banners
	let closestLinkedImagesSection = e.target.closest('section.shopify-section.linked-images-section');

	// cases:
	if (closestQuizStartForm && isButton) { 
		// click > QUIZ:STARTED ====================================================
		// N.B.: precheck if Websummit?
		if (smartMart.isWebsummitQuiz) { // yep, Websummit-specific ...............

			/* N.B.: Use reset as a shortcut to anonymize users after they log out. reset does the following:
				Sets userId to undefined.
				Sets deviceId to a new UUID value.
				With an undefined userId and a new deviceId, the user appears to Amplitude as a new user.
			 */ 
			function regenerateWebsummitUID() {
				const prefix = 'Websummit_user_';
				let firstPart = (Math.random() * 46656) | 0;
				let secondPart = (Math.random() * 46656) | 0;
				firstPart = ("000" + firstPart.toString(36)).slice(-3);
				secondPart = ("000" + secondPart.toString(36)).slice(-3);
				return `${prefix}${firstPart}${secondPart}`;
			}

			// set new random User ID:
			let websummitUID = regenerateWebsummitUID();

			//###
			console.log('### Websummit-specific QUIZ:STARTED websummitUID:',websummitUID);

      // take optional User name:
      let localStorageLanding = (!!window.localStorage && !!window.localStorage.landing)
				? JSON.parse(window.localStorage.landing) : null;
			let landingUsername = (
					!!localStorageLanding &&
					!!localStorageLanding.quiz &&
					!!localStorageLanding.quiz.data &&
					!!localStorageLanding.quiz.data.username
				)
				? localStorageLanding.quiz.data.username : null;
			// prep Event:
			let eventName = 'QUIZ:STARTED';
			let eventProps = {
				'quizUsername': landingUsername,
				'websummitUID': websummitUID
			};
			// N.B.: Shopify analyitics instead of direct Amplitude:
			Shopify.analytics.publish(eventName,eventProps);
			console.log('Shopify analyitics event publish:',eventName,eventProps);

		} else { // nope, regular Quiz started .....................................
			// take requred User name:
			let localStorageQuiz = (!!window.localStorage && !!window.localStorage.quiz)
				? JSON.parse(window.localStorage.quiz) : null;
			let quizUsername = (
					!!localStorageQuiz && 
					!!localStorageQuiz.data && 
					!!localStorageQuiz.data.username
				)
				? localStorageQuiz.data.username : null;
			// prep Event:
			let eventName = 'QUIZ:STARTED';
			let eventProps = {
				'quizUsername': quizUsername
			};
			// N.B.: Shopify analyitics instead of direct Amplitude:
			Shopify.analytics.publish(eventName,eventProps);
			console.log('Shopify analyitics event publish:',eventName,eventProps);
		}

	} else if (isFilterOpen) { 
		// click > FILTER open =====================================================
		// prep:
		let eventName = 'FILTER:OPEN';
		let eventProps = {
			lang: document.body.parentElement.lang,
			searchStringItems: searchStringItems,
		};
		// N.B.: Shopify analyitics instead of direct Amplitude:
		Shopify.analytics.publish(eventName,eventProps);
		console.log('Shopify analyitics event publish:',eventName,eventProps);

		// Filters area for groups 'click' listener,
		document.querySelectorAll('.filters-popup-inner').forEach((item) => {
			item.addEventListener('click',smartMart.handleEvent,{capture: true,});
		})    

	} else if (isFilterClose || isFilterCloseIcon) { 
		// click > FILTER close ====================================================
		// prep:
		let eventName = 'FILTER:CLOSE';
		let eventProps = {
			lang: document.body.parentElement.lang,
			searchStringItems: searchStringItems,
		};
		// N.B.: Shopify analyitics instead of direct Amplitude:
		Shopify.analytics.publish(eventName,eventProps);
		console.log('Shopify analyitics event publish:',eventName,eventProps);

	} else if (isClearAllFilters) { 
		// click > FILTER clear all filters ========================================
		// prep:
		let eventName = 'FILTER:CLEAR';
		let eventProps = {
			lang: document.body.parentElement.lang,
			searchStringItems: searchStringItems,
		};
		// N.B.: Shopify analyitics instead of direct Amplitude:
		Shopify.analytics.publish(eventName,eventProps);
		console.log('Shopify analyitics event publish:',eventName,eventProps);
	
	} else if (eventFilterOptionItem && !isFilterOptionAll) { 
		// click > FILTER single item-related ======================================
		// prep:
		// To catch checked item:
		let theDataFound = null; // ini
		let isTheSameFound = false; // ini
		// loop filter options :Map 
		let filterOptionsMap = e.view?.boostPFS?.filter?.filterTrees?.at(0)?.filterOptions;
		filterOptionsMap.forEach((fomValue, fomKey) => {
			if (isTheSameFound) return; // already found, nothing to do ++++++++++++++
			// loop filter items :Map:
			fomValue.filterItems.forEach((fimValue, fimKey) => {
				if (isTheSameFound) return; // already found, nothing to do ++++++++++++
				let filterItemElement = fimValue?.$element?.get(0);
				let isTheSameElement = (filterItemElement === eventFilterOptionItem);        
				// the same is found ...................................................
				if (isTheSameElement) { 
					isTheSameFound = true; // flag found
					// conbine:
					theDataFound = {
						filterKey: fimKey,
						filterState: searchStringItems.includes(fimKey),
						lang: document.body.parentElement.lang,
						searchStringItems: searchStringItems,
					};
					return; // return after done
				}
			}); 
		});
		// Post-process found:
		let eventName = 'FILTER:'+((theDataFound.filterState)? 'ON':'OFF');
		let eventProps = theDataFound;
		// N.B.: Shopify analyitics instead of direct Amplitude:
		Shopify.analytics.publish(eventName,eventProps);
		console.log('Shopify analyitics event publish:',eventName,eventProps);
		
	} else if (closestHeadingWithImageSection || closestLinkedImagesSection) {
		// click > BANNER:* -related ===============================================
		// prep:
		let eventName = 'BANNER:CLICKED';
		// Full-width banner case: .................................................
		if (closestHeadingWithImageSection) {
			// take details:
			let bannerType = closestHeadingWithImageSection?.dataset?.sectionType;
			// 'https://winest.store/en/pages/quiz' -> /en/pages/quiz
			let bannerHref = closestHeadingWithImageSection?.querySelector('a')?.href;
			let bannerPath = (bannerHref) ? new URL(bannerHref).pathname : null;
			let bannerHeadingText = closestHeadingWithImageSection?.querySelector('a[role="button"] figcapture h2')?.textContent.trim();
			let bannerButtonText = closestHeadingWithImageSection?.querySelector('a[role="button"] .heading-with-image-button')?.textContent.trim();
			// combine:
			let eventProps = {
				bannerType: bannerType,
				bannerPath: bannerPath,
				bannerHeading: bannerHeadingText,
				bannerButton: bannerButtonText
			};
			// N.B.: Shopify analyitics instead of direct Amplitude:
			Shopify.analytics.publish(eventName,eventProps);
			console.log('Shopify analyitics event publish:',eventName,eventProps);
		}
		//TODO implement other Banner types  later (?..)

	} else { 
		// click > OTHER click events: ---------------------------------------------
		//###
		console.log('### OTHER click e.target:',e.target,'\ne:',e);

	}
});
// Quiz retake-related update: -------------------------------------------------
document.addEventListener('questions:generated',(e) => {
	// prep:
	const isQuizPageLoaded = !!e.target.location.pathname.match(/\/pages\/quiz/);
	const isQuizFromRetake = !!e.target.location.search.match(/from=retake/);

	// Quiz retake only:`
	if (!isQuizPageLoaded || !isQuizFromRetake) {
		return; // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	}

	// click > QUIZ:STARTED ======================================================
	const quizStartButton = document.querySelector('#main .quiz-page .quiz-page-start-content .quiz-page-start-form > button'); 
	if (!!quizStartButton) {
		// CLick to 1st question
		quizStartButton.dispatchEvent(new Event('click', {details:{some:"else"}}));

		// Prep/Amplitude: 
		let localStorageQuiz = (!!window.localStorage && !!window.localStorage.quiz)
			? JSON.parse(window.localStorage.quiz) : null;
		let quizUsername = (!!localStorageQuiz && !!localStorageQuiz.data && !!localStorageQuiz.data.username)
			? localStorageQuiz.data.username : null;
		let eventName = 'QUIZ:STARTED';
		let eventProps = {
			'quizUsername': quizUsername
		};
		// N.B.: Shopify analyitics instead of direct Amplitude:
		Shopify.analytics.publish(eventName,eventProps);
		console.log('Shopify analyitics event publish:',eventName,eventProps);
	}
});
// filter:tree (set/clear tag group) -------------------------------------------
// N.B.: by CustomEvent from assets/pnk.boost.static.js
document.addEventListener('filter:tree', (e) => {
	// prep/publish to Shopify.analytics: ========================================
	// prep:
	// e.g. '?pf_t_red=primary::red::LIGHT+BODIED&pf_t_red=primary::red::FRUITY' 
	//  -> ['primary::red::LIGHT BODIED', 'primary::red::FRUITY']
	let searchStringItems = decodeURIComponent(document.location.search).slice(1).split('&').map((item)=>{
			return item.replaceAll(/^[^=]+=/g,'').replaceAll('+', ' ')
	});
	// empty case: [''] -> []
	searchStringItems = (searchStringItems.length == 1 && searchStringItems[0] == '') ? [] : searchStringItems;
	// e.g. "primary::rosé::CITRUS" -> "rosé"
	let tagGroupBaseName = e.detail.params.at(0).split('::').at(1);
	
	// post-process:
	let eventName = 'FILTER:'; // ini
	// eventName cases by e.detail.type:
	if (e.detail.type == 'BUTTON_CHOOSE') eventName = eventName+'ON:TREE';
	if (e.detail.type == 'BUTTON_CLEAR_ALL') eventName = eventName+'OFF:TREE';
	let eventProps = {
		lang: document.body.parentElement.lang,
		tagGroupBaseName: tagGroupBaseName,
		searchStringItems: searchStringItems,
	};
	// N.B.: Shopify analyitics instead of direct Amplitude:
	Shopify.analytics.publish(eventName,eventProps);
	console.log('Shopify analyitics event publish:',eventName,eventProps);
});
// quiz:finished ---------------------------------------------------------------
// N.B.: by CustomEvent from assets/pnk.quiz.static.js
document.addEventListener('quiz:finished', (e) => {
	// prep/publish to Shopify.analytics: ========================================
	let eventName = 'QUIZ:FINISHED';
	let _path = (window.location && window.location.pathname) || '';
	let _source = _path.indexOf('/pages/varlamov') === 0 ? 'varlamov'
		: _path.indexOf('/pages/quiz') === 0 ? 'quiz' : 'other';
	let eventProps = {
		'quizResult': JSON.parse(window.localStorage?.quiz?.trim())?.result,
		'source': _source
	};
	Shopify.analytics.publish(eventName,eventProps);
	console.log('Shopify analyitics event publish:',eventName,eventProps);
});
// tasteProfile:shown ----------------------------------------------------------
// N.B.: by CustomEvent dispatched from assets/pnk.preferences.static.js
// + call TasteProfile wines visibility observer (excl. Websummit-related result page)
document.addEventListener('tasteProfile:shown', (e) => {
	// prep/publish to Shopify.analytics: ========================================
	// Products displayed on Taste profile page,
	// e.detail contains state.products :Array
	let tasteprofileBriefData = [];
	e.detail?.forEach(tasteprofileData => {
		tasteprofileBriefData.push({
			id: tasteprofileData.id,
			title: tasteprofileData.title,
			handle: tasteprofileData.handle,
			matching: tasteprofileData.matching,
			points: tasteprofileData.points
		});
	});
	localStorage.setItem('tasteprofileBrief', JSON.stringify(tasteprofileBriefData));
	const matchingMin = e.detail?.reduce((accumulator, currentProduct) => {
		return (currentProduct.matching < accumulator)
			? currentProduct.matching : accumulator;
	}, 100);
	const matchingMax = e.detail?.reduce((accumulator, currentProduct) => {
		return (currentProduct.matching > accumulator)
			? currentProduct.matching : accumulator;
	}, 0);
	let eventName = 'TASTEPROFILE:SHOWN';
	let eventProps = {
		'productsCount': e.detail?.length,
		'matchingMax': matchingMax,
		'matchingMin': matchingMin,
	};
	Shopify.analytics.publish(eventName,eventProps);
	console.log('Shopify analyitics event publish:',eventName,eventProps);

	// call process TasteProfile results observer
	// to catch RECOMMENDATION:VIEWED intersections: =============================
	// N.B.: excluding Websummit Result page
	if (!smartMart.isWebsummitResult) smartMart.iniTasteprofileObserve();
});

// Theme-specific :CustomEvent events
// setAjaxProductDone ----------------------------------------------------------
// N.B.: by CustomEvent dispatched from assets/bundle.js:
document.addEventListener('setAjaxProductDone', (e) => {
	// prep/publish to Shopify.analytics: ========================================
	const lang = document.querySelector('html').lang;
	const tasteprofileBriefById = JSON.parse(localStorage.tasteprofileBrief).find((i)=>{return i.id == e.detail?.id;});
	let eventName = 'PRODUCT:VIEWED';
	let eventProps = {
		'lang': lang,
		'detail': e.detail,
		'tasteprofileBriefById': tasteprofileBriefById,
	};
	Shopify.analytics.publish(eventName,eventProps);
	console.log('Shopify analyitics event publish:',eventName,eventProps);
});

// Ini Home page SECTION:VIEWED observer and events,
// other (e.g. Websummit-specific) %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
if (document.readyState === 'loading') { // hasn't finished yet
	document.addEventListener('DOMContentLoaded', smartMart.handleLoaded);
} else { // has already fired
	smartMart.handleLoaded();
}

console.log('smartMart Amplitude event listeners (Quiz etc.-related) done');
